
export namespace Dashboards {

  export class CleanStore {
    static readonly type = '[Dashboard] clean store';
  }

  export class GetGlobalData {
    static readonly type = '[Dashboard] Get global infos';
  }

  export class GetParcData {
    static readonly type = '[Dashboard] Get infos for specified parcId';
    constructor( public parcId: number) {}
  }

}
